import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { DeviceService } from '../device/device.service';
import { BlackSimpleToasterService } from '../toasters/black-simple-toaster.service';
import { VideoRoomService } from '../video-room.service';

import { ActiveSpeakerService } from './../active-speaker/active-speaker.service';
import ActiveSpeakerListener from './listeners/active-speaker.listener';
import MuteListener from './listeners/mute-listener';
import NetworkConnectionListener from './listeners/network-connection.listener';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  private toastNotificationService = inject(BlackSimpleToasterService);
  private videoRoomService = inject(VideoRoomService);
  private deviceService = inject(DeviceService);
  private activeSpeakerService = inject(ActiveSpeakerService);
  private store = inject(Store);

  private connection?: NetworkConnectionListener;
  private muteListener?: MuteListener;
  private activeSpeakerListener?: ActiveSpeakerListener;

  public initialize(): void {
    this.connection = new NetworkConnectionListener(this.toastNotificationService, this.videoRoomService);
    this.muteListener = new MuteListener(this.toastNotificationService, this.deviceService, this.store);
    this.activeSpeakerListener = new ActiveSpeakerListener(this.deviceService, this.store, this.activeSpeakerService);

    this.connection.init();
  }

  public async destroy(): Promise<void> {
    this.connection?.end();
    this.connection = undefined;

    await this.muteListener?.destroy();
    this.muteListener = undefined;

    await this.activeSpeakerListener?.destroy();
    this.activeSpeakerListener = undefined;
  }
}
